import { NgClass } from '@angular/common'
import { Component, EventEmitter, inject, Input, LOCALE_ID, NgZone, OnChanges, OnInit, Optional, Output, SimpleChanges, ViewEncapsulation } from '@angular/core'
import { ControlContainer, NgForm, FormsModule } from '@angular/forms'

import { PrimeTemplate } from 'primeng/api'
import { AutoComplete } from 'primeng/autocomplete'
import { isEmpty, map } from 'lodash-es'

import { ProjectContractsApi } from '@app/apis/project-contracts.api'
import { DetailMode } from '@app/components/generic/generic.constants'
import type { ArchivesProjectContractsProjectContractList } from '@app/generated/api/model'
import { RequiredFieldTextComponent } from '../required-field-text.component'

@Component({
  selector: 'app-projects-field',
  templateUrl: 'project-contracts-field.component.html',
  styleUrl: 'project-contracts-field.component.less',
  encapsulation: ViewEncapsulation.None,
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    AutoComplete,
    FormsModule,
    NgClass,
    PrimeTemplate,
    RequiredFieldTextComponent,
  ],
})
export class ProjectContractsFieldComponent implements OnInit, OnChanges {
  public readonly projectContractsApi = inject(ProjectContractsApi)
  public readonly zone = inject(NgZone)
  public readonly locale = inject(LOCALE_ID)

  @Input() projectCodes?: string[] | null
  @Input() required: boolean = false
  @Input() recommended: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() projectCodesChange = new EventEmitter<string[] | null>()

  public selectedProjectCodes: string[] = []
  public allProjectCodes: string[] = []

  public filterLabelField: string = 'label_en'
  protected readonly DetailMode = DetailMode

  ngOnInit (): void {
    if (this.locale === 'fr') {
      this.filterLabelField = 'label_fr'
    }
    this.selectedProjectCodes = this.projectCodes ?? []
  }

  ngOnChanges (changes: SimpleChanges<ProjectContractsFieldComponent>) {
    const projectChange = changes.projectCodes
    if (projectChange) {
      this.selectedProjectCodes = this.projectCodes ?? []
      setTimeout(() => {
        this.projectCodesChange.emit(this.selectedProjectCodes)
      })
    }
  }

  /**
   * Return project codes matching the given code using an `icontains` matcher.
   * This is necessary because we cannot present a list of *all* projects: it must be pre-filtered.
   */
  getProjectSuggestions ($event: { query: string, originalEvent: any }) {
    this.projectContractsApi.list({ limit: 100, ordering: 'code_project', code_project: $event.query }).subscribe(
      (res) => {
        this.allProjectCodes = map(res.results, (project: ArchivesProjectContractsProjectContractList) => {
          return project.code_project
        })
      })
  }

  /**
   * return whether the field's value is undefined or empty
   */
  isEmpty () {
    return isEmpty(this.projectCodes)
  }
}
